import React, { useContext } from 'react';
import { ExerciseTranslationsContext } from '../../contexts/ExerciseTranslationsContext.js';
import { ModalDialog, Dialog } from '../../../dialog/index.js';
import { Button } from '../../../button/index.js';

const AssignmentExpiredDialog = ({ onClose }) => {
    const translations = useContext(ExerciseTranslationsContext);
    return (React.createElement(ModalDialog, { id: 'assignment-expired-dialog', onClose: onClose, closeTitle: translations.closeDialog, closeViaEscape: true, className: 'exercise-dialogs' },
        React.createElement(Dialog.Header, { title: translations.assignmentExpiredDialog.title }),
        React.createElement(Dialog.Body, null,
            React.createElement("p", null, translations.assignmentExpiredDialog.message)),
        React.createElement(Dialog.Footer, null,
            React.createElement(Button, { variant: 'primary', onClick: onClose }, translations.assignmentExpiredDialog.buttons.close))));
};

export { AssignmentExpiredDialog };
